import {
	IonButton,
	IonCheckbox,
	IonCol,
	IonIcon,
	IonImg,
	IonItem,
	IonLabel,
	IonRadio,
	IonRadioGroup,
	isPlatform,
} from "@ionic/react";
import { chevronBackOutline } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
// import "../../global.scss";
import * as constants from "../../../constants";
import { updateDoc, COLLECTIONS } from "../../../firebase";
import {
	workshopTemplate,
	getServiceDetails,
	saveWorkshopStandard,
	addItemToCart,
	getCartItemsList,
	// getMultiServiceData,
	saveSelectedPartDetails,
	saveOrientationOfVehicle,
	clearBodyDamageTypes,
	clearDamageTypes,
	saveServiceSearchData,
} from "../../../Store/Actions";
import { checkMediaQuery } from "../../../utils";
import { ToastMessage } from "../../../utils/toastMessage";
import "../Workshop/workshopQuality.scss";

const WorkshopQuality: React.FC = (props: any) => {
	const [state, setState] = React.useState("");
	const [serviceDetails, setServiceDetails] = React.useState<any>({});
	const [toast, setToast] = React.useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});
	React.useEffect(() => {
		// console.log("Workshop Quality ............", props);
		getData();
		fetchData();
	}, [props.sliderCatelogVehicleId]);

	// React.useEffect(() => {
	//   const arr = props.cart_items.map((ele: any) => ele.serviceId);
	//   if (arr.length > 0) {
	//     props.getMultiServiceData(arr);
	//   }
	// }, [props.cart_items]);

	const addToCart = async (btnlabel: string) => {
		try {
			const { addOnSections, service, pricing, serviceProviderWorkshopList } =
				serviceDetails;
			const { model, currency, amount } = pricing;
			const { serviceId } = service;
			const { addOn, fromBodyPanel = false } = props.location.state;
			if (props.service_data.map((ele: any) => ele.serviceId).includes(serviceId)) {
				throw Error(constants.SERVICE_ALREADY_ADDED);
			}
			const payload = {
				//addOnsSelected: !!addOnSections ? addOn : [],
				addOnsSelected: !!addOn.length ? addOn : [],
				appliedPrice: {
					amount: amount,
					currency: currency,
					model: model,
				},
				damageTypeId: service.damageTypeId || "",
				partId: service.partId || "",
				partDisplayName: service.partDisplayName || "",
				recommended: true,
				serviceId: serviceId,
				workshopId: "",
			};

			// console.log("WID Check === 83 === ", payload);
			await props.addItemToCart(payload);
			await props.getCartItemsList();
			await props.saveServiceSearchData({});
			if (fromBodyPanel) {
				await props.saveSelectedPartDetails({});
				await props.saveOrientationOfVehicle({});
				await props.clearDamageTypes();
				await props.clearBodyDamageTypes();
			}
			if (btnlabel === constants.BOOK_NOW && checkMediaQuery()) {
				await props.history.push({
					pathname: "/portal/cart",
					state: "workshop",
				});
			} else {
				await props.history.push("/portal/book_service");
			}
		} catch (e: any) {
			setToast({
				showToast: true,
				toastMessage: e.message,
				severity: "warning",
			});
		}
	};

	const getData = async () => {
		// await props.workshopTemplate();
		// if (!!props.location.state.workshopQuality.model) {
		//   setState(props.location.state.workshopQuality.model);
		// }
		await setServiceDetails(props.location.state);
	};

	const fetchData = async () => {
		const { service = {}, workshopQuality = {} } = props.location.state;
		if (
			Object.keys(service).length &&
			Object.keys(workshopQuality).length &&
			props.sliderCatelogVehicleId
		) {
			const vMake = props.userVehiclesList.find(
				(item: any) => item.catalogVehicleId === props.sliderCatelogVehicleId
			);

			await Promise.all([
				// console.log("12222222 =============", props),
				props.getServiceDetails(service.serviceId, {
					catalogVehicleId: props.sliderCatelogVehicleId,
					pricingSegment:
						!!workshopQuality.model && workshopQuality.model === "premium"
							? "standard"
							: "premium",
					id: service.serviceId,
					clientName: constants.CLIENT_NAME,
					make: vMake.make,
				}),
				props.workshopTemplate(),
			]);
		}
	};

	const setSelectedWorkshopTemplate = async (value: any) => {
		const { service = {} } = props.location.state;
		const { uid, settings } = props;
		// setState(value);
		await updateDoc(
			uid,
			{
				settings: {
					...settings,
					pricingSegment: value,
				},
			},
			COLLECTIONS.USERS
		);
		await props.saveWorkshopStandard(value);
		// console.log("1533333 =============", service);
		const vMake = props.userVehiclesList.find(
			(item: any) => item.catalogVehicleId === props.sliderCatelogVehicleId
		);
		await props.getServiceDetails(service.serviceId, {
			catalogVehicleId: props.sliderCatelogVehicleId,
			pricingSegment: value,
			clientName: constants.CLIENT_NAME,
			make: vMake.make,
		});
		await setServiceDetails(props.servicesDetails);
	};
	return (
		<>
			<IonCol className="middle_panle res_bg_color" size-md="6">
				<div
					className="personal_details_div workshowQua_header_floating"
					style={{ paddingTop: isPlatform("android") ? 20 : 0 }}
				>
					<div className="personal_details_div_child paddingLeft25 wholeApp">
						<IonImg
							src={
								checkMediaQuery()
									? "/images/gray_backarrow.svg"
									: "/images/back_arrow.svg"
							}
							className="back_arrow"
							onClick={() => {
								// console.log("XYZ ....", props);
								props.location.state.fromBodyPanel
									? props.history.push({
											pathname: "/portal/body-panel",
									  })
									: props.history.push({
											pathname: "/portal/service_details",
											state: {
												...serviceDetails,
												addOn: props.location.state.addOn,
											},
									  });
							}}
						/>
						<IonLabel className="personal_details_labels" color="secondary">
							{constants.WORKSHOP_QUALITY}
						</IonLabel>
						<div />
					</div>
				</div>
				<div className="ws_content_container">
					<div
						className={
							isPlatform("ios")
								? "personal_details_text workshop-quality-div marginTop_80 wqMarginTop"
								: "personal_details_text workshop-quality-div marginTop_80"
						}
					>
						<div className="service-item">
							<IonImg
								src={props.location.state.service.imageUrl || "/images/brake_image.svg"}
								className="service-item-image"
							/>
							<div className="service-details">
								<IonLabel className="service-name" color="secondary">
									{props.location.state.service.displayName}
								</IonLabel>
								<IonLabel className="service-summary-details" color="tertiary">
									{props.location.state.service.shortDescription}
								</IonLabel>
							</div>
						</div>
						<div className="select-your-preference">
							<IonLabel className="select-your-preference-label" color="tertiary">
								{constants.SELECT_YOUR_PREFERENCE}
							</IonLabel>
						</div>
					</div>
					<IonRadioGroup
						value={
							props.settings.pricingSegment.charAt(0).toUpperCase() +
								props.settings.pricingSegment.slice(1) || ""
						}
						// value={!!state && state.charAt(0).toUpperCase() + state.slice(1)}
						className="radio-group"
					>
						{Boolean(props.workshopSegments) &&
							props.workshopSegments.map((ele: any, index: any) => (
								<div
									className="service-types-info"
									key={index}
									onClick={() => setSelectedWorkshopTemplate(ele.displayName)}
								>
									<div className="service-type-standard">
										<div className="service-amount-div">
											<IonItem className="border_bottom" lines="none">
												<IonLabel
													className="wc_radio_label"
													color={
														ele.displayName ===
														props.settings.pricingSegment.charAt(0).toUpperCase() +
															props.settings.pricingSegment.slice(1)
															? "primary"
															: "tertiary"
													}
												>
													{ele.displayName}
												</IonLabel>
												<IonRadio
													tabIndex={0}
													slot="start"
													className="wc_ion_radio"
													value={ele.displayName}
													onClick={() => setSelectedWorkshopTemplate(ele.displayName)}
													mode="md"
												/>
											</IonItem>
											<IonLabel
												className="roboto"
												color={
													ele.displayName ===
													props.settings.pricingSegment.charAt(0).toUpperCase() +
														props.settings.pricingSegment.slice(1)
														? "primary"
														: "tertiary"
												}
											>{`${constants.RupeeSymbol} ${
												Boolean(Object.keys(props.servicesDetails || {}).length) &&
												ele.name.toLowerCase() ===
													!!props.servicesDetails.pricing.model &&
												props.servicesDetails.pricing.model
													? props.servicesDetails.pricing.amount
													: Number(props.location.state.workshopQuality.amount)
											}`}</IonLabel>
										</div>
										<div className="service-contents">
											{ele.features.map((ele: any, index: any) => (
												<div key={index} className="service-content-item">
													<div className="check_img">
														<IonImg src="/images/whatsInclude.svg" />
													</div>
													<div className="whats_included_point sd_checkmark">
														<IonLabel className="service-content-label font_secondary_color">
															{ele}
														</IonLabel>
													</div>
												</div>
											))}
										</div>
									</div>
								</div>
							))}
					</IonRadioGroup>
					<div className="service-analytics">
						<div className="service-analytics-content">
							<IonLabel color="secondary" className="service-used-count">
								{constants.NO_OF_USERS_USE_PREMIUM}
							</IonLabel>
						</div>
						<div className="service-analytics-content">
							<IonLabel color="tertiary" className="service-quality-difference">
								{constants.SERVICE_QUALITY_COMPARED_TO_STANDARD}
							</IonLabel>
						</div>
					</div>
				</div>
				<div className="page-actions workshop_footer wqActionBtnsPaddBtm">
					<IonButton
						fill="outline"
						color="primary"
						className="page-action-buttons"
						onClick={() => addToCart(`${constants.ADD_TO_CART}`)}
					>
						{constants.ADD_TO_CART}
					</IonButton>
					<IonButton
						fill="solid"
						className="page-action-buttons book_now_button"
						onClick={() => addToCart(`${constants.BOOK_NOW}`)}
					>
						{constants.BOOK_NOW}
					</IonButton>
				</div>
				<ToastMessage
					showToast={toast.showToast}
					ToastMessage={toast.toastMessage}
					severity={toast.severity}
					onDidDismiss={() => {
						setToast({
							showToast: false,
							toastMessage: "",
							severity: "",
						});
					}}
				/>
			</IonCol>
		</>
	);
};

export default connect(
	({
		auth: { uid, settings, selectedVehicleRef },
		userInfo: { sliderCatelogVehicleId, userVehiclesList, servicesDetails },
		workshop: { workshopSegments },
		cart: { cart_items, service_data },
	}: any) => ({
		uid,
		settings,
		workshopSegments,
		sliderCatelogVehicleId,
		selectedVehicleRef,
		userVehiclesList,
		servicesDetails,
		cart_items,
		service_data,
	}),
	{
		workshopTemplate,
		getServiceDetails,
		saveWorkshopStandard,
		addItemToCart,
		getCartItemsList,
		// getMultiServiceData,
		saveSelectedPartDetails,
		saveOrientationOfVehicle,
		clearBodyDamageTypes,
		clearDamageTypes,
		saveServiceSearchData,
	}
)(WorkshopQuality);
